// Числата над таблицата на „Дневни отчети → Заведение".
//
// Всички суми идват от BE като Decimal-НИЗОВЕ и се сумират едва след
// `parseDecimal` — иначе „12.50" + „7.00" би дало конкатенация.
//
// „Друго" е остатъкът извън в брой и карта („По сметка" и персонализираните
// методи). BE-то го смята като `total − cash − card`, затова е верен и за
// отчетите, записани преди разбивката по методи да съществува — без него
// заведение, което приема плащане по сметка, вижда оборот, който не се
// покрива от двете колони.
//
// `formatWorkDay`, `isZeroAmount` и `shareOf` НЕ се преповтарят тук — двата
// таба на „Дневни отчети" смятат едно и също и делят помощниците от
// `dailyReports/personalReportsMath.ts`.

import { EM_DASH, parseDecimal } from "../../../../components/dataTable";
import type { EstablishmentReport } from "../../../../api/reports";

export type EstablishmentReportsSummary = {
  /** Брой пуснати отчети НА ЗАВЕДЕНИЕТО в периода. */
  reports: number;
  bills: number;
  total: number;
  cash: number;
  card: number;
  other: number;
};

export const summarizeEstablishmentReports = (
  reports: readonly EstablishmentReport[],
): EstablishmentReportsSummary => {
  const summary: EstablishmentReportsSummary = {
    reports: reports.length,
    bills: 0,
    total: 0,
    cash: 0,
    card: 0,
    other: 0,
  };

  for (const report of reports) {
    // Единственото цяло число, което влиза в показателите — броячите по метод
    // са Decimal, защото смесеното плащане се разпределя дробно между тях.
    summary.bills += Number(report.total_bills_count ?? 0);
    summary.total += parseDecimal(report.total_amount);
    summary.cash += parseDecimal(report.cash_amount);
    summary.card += parseDecimal(report.card_amount);
    summary.other += parseDecimal(report.other_amount);
  }

  return summary;
};

/**
 * Кой е съставил отчета.
 *
 * Отчетите отпреди снимката на името нямат `created_by_name` — тогава остава
 * само id-то на съставилия. То е по-малко от нищо, но е проверимо; тире би
 * скрило, че отчетът изобщо има автор. Същият избор прави и печатният документ
 * (`EstablishmentReportPreviewModal`).
 */
export const preparedByLabel = (
  report: Pick<EstablishmentReport, "created_by_name" | "created_by_user_id">,
): string => {
  const name = report.created_by_name?.trim();
  if (name) return name;
  return report.created_by_user_id ? `#${report.created_by_user_id}` : EM_DASH;
};
